import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import type { TField } from '~/src/components/RequestForm';
import type { IPopupProps } from '~/src/features/router/order-card';

/**
 * Кол-во слайдов в секции каталог для tablet
 *
 * @name data.COUNT_SLIDE_TABLET
 * @type {number}
 */
export const COUNT_SLIDE_TABLET = 2;

/**
 * Кол-во слайдов в секции каталог для mobile
 *
 * @name data.COUNT_SLIDE_MOBILE
 * @type {number}
 */
export const COUNT_SLIDE_MOBILE = 1;

/**
 * Базовый урл фоновой картинки хедера
 *
 * @name data.HEADER_IMG_URL
 * @type {string}
 */
export const HEADER_IMG_URL = '/static/images/yandex-landing/header-img-';

/**
 * Кол-во пунктов в подсекции умная колонка (карусель)
 *
 * @name data.COUNT_CAROUSEL_SUB_ITEMS
 * @type {number}
 */
export const COUNT_CAROUSEL_SUB_ITEMS = 3;

/**
 * Красный цвет для чекбоксов
 *
 * @name data.RED_COLOR_CHECKBOX
 * @type {string}
 */
export const RED_COLOR_CHECKBOX = '#e30813';

/**
 * Категории блоков раздела "Ваши плюсы"
 *
 * @name data.EPlusesCategory
 * @type {enum}
 */
export enum EPlusesCategory {
    musicAndMovie = 'musicAndMovie',
    useNow = 'useNow',
    freeDelivery = 'freeDelivery',
    installment = 'installment',
}

/**
 * Начальное состояние попапа
 *
 * @name utils.initialPopupState
 * @returns {Omit<IPopupProps, 'isOrderOpened'>}
 */
export const initialPopupState: Omit<IPopupProps, 'isOrderOpened'> =  {
    isResultOpened: false,
    resultTitle: '',
    resultText: '',
    resultType: EResultPopupStatus.SUCCESS,
};

/**
 * Кол-во слайд блоков в секции умная колонка
 *
 * @name utils.CAROUSEL_STATION_COUNT_SLIDES
 * @returns {number}
 */
export const CAROUSEL_STATION_COUNT_SLIDES = 5;

/**
 * Цена в секции хедере
 *
 * @name utils.PRICE_OF_ECONOMY
 * @returns {string}
 */
export const PRICE_OF_ECONOMY = '1 097';

/**
 * Изначальное состояние инпутов формы ос
 *
 * @name utils.STATE_DEFAULT_INPUTS
 * @returns {TField}
 */
export const STATE_DEFAULT_INPUTS: TField = {
    value: '',
    isValid: false,
    clearInput: () => undefined,
};

/**
 * Путь ко всей статике страницы
 *
 * @name data.DEFAULT_URL
 * @type {string}
 */
export const DEFAULT_URL = '/static/images/yandex-landing/';

/**
 * Путь к изображениям Яндекс станций
 *
 * @name data.STATION_IMG_URL
 * @type {string}
 */
export const STATION_IMG_URL = `${DEFAULT_URL}stations/yandex-station-`;

/**
 * Схема для постороения grid-таблицы с areas
 *
 * @name data.GRID_ORDER_CATEGORY
 * @type {[key: string]: Record<string, string>}
 */
export const GRID_ORDER_CATEGORY: { [key: string]: Record<string, string> } = {
    desktop: {
        firstRow: `${EPlusesCategory.musicAndMovie} ${EPlusesCategory.musicAndMovie} ${EPlusesCategory.musicAndMovie}`,
        secondRow: `${EPlusesCategory.freeDelivery} ${EPlusesCategory.installment} ${EPlusesCategory.useNow}`,
    },
    tablet: {
        firstRow: `${EPlusesCategory.musicAndMovie} ${EPlusesCategory.freeDelivery}`,
        secondRow: `${EPlusesCategory.installment} ${EPlusesCategory.useNow}`,
    },
    mobile: {
        firstRow: `${EPlusesCategory.musicAndMovie}`,
        secondRow: `${EPlusesCategory.freeDelivery}`,
        thirdRow: `${EPlusesCategory.installment}`,
        fourthRow: `${EPlusesCategory.useNow}`,
    },
};
